// Site Header Block
($ => {

    /* * * * * * * * * * * * * * *
     * Fixed Header
     * Fixed Header changes background color on scroll 
    * * * * * * * * * * * * * * */
    const header = $('.ttr-site-header');

    // Update header class based on scroll position
    const updateHeaderOnScroll = () => {
        if (window.scrollY > 10) {
            header.addClass('is-scrolled');
        } else {
            header.removeClass('is-scrolled');
        }
    };

    // Initialize header state on page load
    updateHeaderOnScroll();

    // Update header on scroll
    $(window).on('scroll', updateHeaderOnScroll);

    /* * * * * * * * * * * * * * */
    /* Search Form
    /* * * * * * * * * * * * * * */
    const searchForm = $('.ttr-site-header__search-form');
    const searchToggle = $('.js-search-toggle');
    const searchInput = $('.js-search-input');
    const searchLabel = $('.ttr-site-header__search-form .wp-block-search__label');
    const searchWrapper = $('.ttr-site-header__search-form .wp-block-search__inside-wrapper');

    // Need to set inline width on load for smooth transition
    $(window).on('load', function () {
        searchLabel.attr('data-width', searchLabel.outerWidth(true));
        searchForm.css('width', searchForm.outerWidth(true));
        searchWrapper.css({
            position: 'absolute',
            right: 0,
            top: '50%',
            transform: 'translateY(-50%)'
        });
    });

    searchToggle.on('click', function (event) {
        if (!searchForm.hasClass('is-active')) {
            event.preventDefault();
            searchInput.focus();
        }
    });

    searchInput.on('focus', function () {
        searchForm.addClass('is-active');
        searchLabel.animate({ width: 0 }, 300);
    });

    searchInput.on('blur', function () {
        searchForm.removeClass('is-active');
        searchLabel.animate({ width: searchLabel.data('width') }, 300);
    });

    /* * * * * * * * * * * * * * */
    /* Mobile Menu
    /* * * * * * * * * * * * * * */
    const mobileToggle = $('.js-mobile-toggle');
    const mobileClose = $('.js-mobile-close');
    const mobileOverlay = $('.js-mobile-overlay');

    // Clone all .wp-block-navigation elements from .ttr-site-header into .ttr-site-header__mobile-overlay__menu
    const navs = $('.ttr-site-header nav');
    const mobileMenu = $('.ttr-site-header__mobile-overlay__menu');
    mobileMenu.empty(); // Clear previous clones
    navs.each(function () {
        // Clone the nav
        const $clone = $(this).clone(true, true);
        // Find all descendants with class 'has-child'
        $clone.find('.has-child').each(function () {
            const $child = $(this);
            // Remove all data attributes
            $.each(this.attributes, function() {
                if(this.name.startsWith('data-')) {
                    $child.removeAttr(this.name);
                }
            });
            // Remove the class 'open-on-hover-click'
            $child.removeClass('open-on-hover-click');
        });
        // Append the cleaned clone
        mobileMenu.append($clone);
    });

    const openMenu = () => {
        mobileOverlay.scrollTop(0);
        mobileOverlay.addClass('is-active');
        $('body').css('overflow', 'hidden');
    };

    const closeMenu = () => {
        mobileOverlay.removeClass('is-active');
        $('body').css('overflow', '');
    };

    mobileToggle.on('click', openMenu);

    mobileClose.on('click', closeMenu);

    $(document).on('keydown', function (event) {
        if (event.key === 'Escape' && mobileOverlay.hasClass('is-active')) {
            closeMenu();
        }
    });

    $(document).on('click', '.menu-item [aria-haspopup="true"]', function (event) {
        event.preventDefault();
    });

})(jQuery);
